import {BuffController} from "../sim_types";

export function removeSelf(controller: BuffController): void {
    controller.removeSelf();
}
